import { render, staticRenderFns } from "./ObjectBlock.vue?vue&type=template&id=0cb31738&scoped=true"
import script from "./ObjectBlock.vue?vue&type=script&lang=js"
export * from "./ObjectBlock.vue?vue&type=script&lang=js"
import style0 from "./ObjectBlock.vue?vue&type=style&index=0&id=0cb31738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb31738",
  null
  
)

export default component.exports